<template>
  <section
    ref="carouselRef"
    :class="['flex-wrap gap-4 grid w-full overflow-scroll carousel carousel-start', layout]"
  >
    <slot />
  </section>

  <div
    v-if="pages > colsPerPage"
    class="flex flex-row justify-end items-center gap-2 mt-2"
  >
    <button
      @click="onClickPrev"
      :disabled="isFirst"
      class="disabled:bg-zinc-100 enabled:bg-black disabled:text-black enabled:text-white btn btn-circle btn-sm"
    >
      <font-awesome-icon :icon="['fass', 'chevron-left']" />
    </button>
    <button
      @click="onClickNext"
      :disabled="isLast"
      class="disabled:bg-zinc-100 enabled:bg-black disabled:text-black enabled:text-white btn btn-circle btn-sm"
    >
      <font-awesome-icon :icon="['fass', 'chevron-right']" />
    </button>
  </div>
</template>

<script setup>
import { computed, watch, onMounted, ref } from "vue";

import { useScroll, useElementSize, useResizeObserver } from "@vueuse/core";


const props = defineProps({
    layout: String
});

const carouselRef = ref(null);
const itemWidth = ref(0)
const itemHeight = ref(0)

const { x } = useScroll(carouselRef, { behavior: 'smooth' })

const { width: carouselWidth, height: carouselHeight } = useElementSize(carouselRef)

const itemsCount = ref();

useResizeObserver(carouselRef, (entries) => {
    const [entry] = entries
    
    itemWidth.value = entry?.target?.firstElementChild?.clientWidth || 0
    itemHeight.value = entry?.target?.firstElementChild?.clientHeight || 0

    itemsCount.value = entry?.target?.children.length || 0

})

const currentPage = computed(() => {
    if (!itemWidth.value) {
        return 0
    }

    return Math.round(x.value / itemWidth.value)  + 1
})

const colsPerPage = computed(() => {
    if (!itemWidth.value) {
        return 0
    }

    return Math.round(carouselWidth.value / itemWidth.value)
})

const rowsPerPage = computed(() => {
    if (!itemWidth.value) {
        return 0
    }

    return Math.round(carouselHeight.value / itemHeight.value)
})

const pages = computed(() => {
    if (!itemWidth.value) {
        return 0
    }
    return Math.ceil((itemsCount.value / colsPerPage.value)  ) 
   
})

const isFirst = computed(() => currentPage.value <= 1)
const isLast = computed(() => currentPage.value === pages.value)

function onClickNext() {
    x.value += itemWidth.value;
}

function onClickPrev() {
    x.value -= itemWidth.value;
}


</script>

